export default "__VITE_ASSET__s$kzf72r__"